import { useCallback, useEffect, useState } from "react";
import { useRecoilValueLoadable } from "recoil";

import { ReinfolibPrice } from "@/api/generated";
import { PropallyApiFactory } from "@/module/CustomApiFactory";
import { MonthlyCashflowResultsOnToday } from "@/view_models/balancesheetSelectors";
import { SelectedProperty } from "@/view_models/propertySelectors";

// 物件詳細画面初期データ取得用 hook
export const useManagementDetailData = () => {
  const properties_loadable = useRecoilValueLoadable(SelectedProperty);
  const cashflow_result_loadable = useRecoilValueLoadable(MonthlyCashflowResultsOnToday);

  if (properties_loadable.state === "loading" || cashflow_result_loadable.state === "loading") {
    return { isLoading: true };
  }

  if (properties_loadable.state === "hasError") {
    return { error: properties_loadable.contents };
  }

  if (cashflow_result_loadable.state === "hasError") {
    return { error: cashflow_result_loadable.contents };
  }

  return {
    isLoading: false,
    property: properties_loadable.contents || null,
    cashflow_result: cashflow_result_loadable.contents || null,
  };
};

// 成約事例取得hook
// 他の場所で使用する場合、必要に応じてファイル分割しても良い
export const useFetchNearbyPrices = (propertyId: number) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [nearbyPrices, setNearbyPrices] = useState<ReinfolibPrice[]>(undefined);

  const fetch = useCallback(async () => {
    setLoading(true);

    const fp = PropallyApiFactory();
    try {
      const data = await fp.v1PropertiesPropertyIdNearbyPricesGet(propertyId, { withCredentials: true });
      if (data.status === 200) {
        setNearbyPrices(data.data);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, [setNearbyPrices, setLoading]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { nearbyPrices, loading };
};
